/* 🤖 this file was generated by svg-to-ts */
export const matIconHeight: {
  name: 'height';
  data: string;
} = {
  name: 'height',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"/></svg>`
};
